import React from "react";
import WmaListEntityPage from "../wma-list";

const LanguageSelectionPage = (props) => {
    return <WmaListEntityPage {...props} rootClassNames="language-selection" />;
};

export default LanguageSelectionPage;
